import React, { useEffect, useRef } from 'react'

function MiniProjectsModal({ project, onClose }) {
  const closeRef = useRef(null)

  useEffect(() => {
    if (!project) return
    const onKey = (e) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    if (closeRef.current && typeof closeRef.current.focus === 'function') closeRef.current.focus()
    return () => window.removeEventListener('keydown', onKey)
  }, [project, onClose])

  if (!project) return null

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={`Mini project details: ${project.title}`}
      onClick={(e) => { if (e.target === e.currentTarget) onClose() }}
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.6)',
        zIndex: 2000,
        padding: 16
      }}
    >
      <div style={{ maxWidth: 640, width: '100%', background: '#fff', borderRadius: 10, overflow: 'hidden', boxShadow: '0 14px 48px rgba(0,0,0,0.25)' }}>
        <div style={{ padding: 16, borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h4 style={{ margin: 0 }}>{project.title}</h4>
            <div style={{ color: '#666', fontSize: 13 }}>{project.role}</div>
          </div>
          <div>
            <button ref={closeRef} aria-label="Close project" onClick={onClose} style={{ background: 'transparent', border: 'none', fontSize: 18, cursor: 'pointer' }}>✕</button>
          </div>
        </div>

        <div style={{ padding: 16 }}>
          <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <div style={{ flex: '0 0 120px' }}>
              {project.imageUrl ? (
                <div style={{ width: 120, height: 80, background: `url(${project.imageUrl}) center/cover no-repeat`, borderRadius: 6 }} />
              ) : (
                <div style={{ width: 120, height: 80, background: '#eef2ff', borderRadius: 6 }} />
              )}
            </div>

            <div style={{ flex: 1 }}>
              <p style={{ margin: 0, color: '#333', lineHeight: 1.5 }}>{project.description}</p>

              {project.technologies && project.technologies.length > 0 && (
                <div style={{ marginTop: 10, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {project.technologies.map(t => (
                    <span key={t} style={{ background: '#f5f7ff', padding: '6px 8px', borderRadius: 6, fontSize: 12 }}>{t}</span>
                  ))}
                </div>
              )}

              <div style={{ marginTop: 12, display: 'flex', gap: 10 }}>
                {project.liveUrl && <a href={project.liveUrl} target="_blank" rel="noreferrer" style={{ color: '#667eea', textDecoration: 'none', fontWeight: 700 }}>Live</a>}
                {project.repoUrl && <a href={project.repoUrl} target="_blank" rel="noreferrer" style={{ color: '#667eea', textDecoration: 'none', fontWeight: 700 }}>Source</a>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MiniProjectsModal
